// lib/desktop/open-external.ts
//
// Abre una URL EXTERNA en el navegador del sistema.
//
// En la web basta con window.open. En el webview de Tauri, un `<a target="_blank">`
// o window.open hacia una URL http(s) externa NO abre nada (el webview no es un
// navegador con ventanas nuevas), así que delegamos al plugin `opener` para que
// abra el navegador por defecto del SO. Es también el mecanismo con el que
// lanzamos la URL de OAuth de Google en desktop (ver google-oauth-desktop.ts).

import { isDesktopApp } from "@/lib/edition/is-desktop";

export async function openExternal(url: string): Promise<void> {
  if (isDesktopApp()) {
    try {
      const { openUrl } = await import("@tauri-apps/plugin-opener");
      await openUrl(url);
      return;
    } catch (e) {
      // Fallback best-effort si el plugin no estuviera disponible.
      console.error("openExternal (tauri) falló; intento window.open", e);
    }
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
